import { memo } from 'react';

import { RadioLabel } from '@gem/ui-kit';

import { IRadioItemProps } from './RadioItem.types';

export const RadioItem = memo<IRadioItemProps>((props) => {
  const {
    input: { name, checked, onChange, value },
    label,
    description,
  } = props;

  return (
    <RadioLabel
      value={value}
      isActive={!!checked}
      title={label}
      description={description}
      onChange={(): void => onChange(value)}
      name={name}
    />
  );
});
